// Validate functions

export const isValidEmailAddress = (email: string): boolean => /^[\w.%+-]+@[a-zA-Z\d.-]+\.[a-zA-Z]{2,}$/.test(email)

export const isValidPhoneNumber = (phone: string): boolean => /^\d{3,15}$/.test(phone)
